var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.companyId)?_c('CrmFunnelFormApi',{attrs:{"companyId":_vm.companyId,"funnelId":_vm.funnelId},on:{"change":_vm.onChange,"close":function($event){return _vm.$emit('finish', true)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }